'use strict';

var processInclude = require('base/util');
var baseFiles = {
  detail: require('core/product/detail'),
  addToCartStickyBar: require('./product/addToCartStickyBar'),
  completeYourLook: require('./product/completeYourLook'),
  initPDPVideoModals: require('./product/pdpvideo').initPDPVideoModals
};
$(document).ready(function () {
  Object.keys(baseFiles).forEach(function (key) {
    processInclude(baseFiles[key]);
  });
});
module.exports = {
  baseFiles: baseFiles
};